import React from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Checkbox, Segment, Label, FormField, Header as Heading } from 'semantic-ui-react'
import AuthService from '../../../service/auth';
import FiledsValidator from '../../../utils/validation/fieldsValidator';
import Loader from '../../../components/loader';
import Alert from '../../../utils/alert';
import Header from '../../landing/header';
import Footer from '../../landing/footer';
import './registration.css';

class RegistrationForm extends React.Component {
    constructor(props) {
        super(props);
        var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
        this.filedsValidator = new FiledsValidator(["fullName", "password", "passwordConfirmation", "email"],
            {
                "email": { validate: val => val.match(emailRegex) && val.length < 51 && val.length > 3, msg: "The email is invalid." },
                "fullName": { validate: val => val.length < 51 && val.length > 3, msg: "It must be shorter than 50 symbols and longer than 3" },
                "password": { validate: val => val.length > 5, msg: "It must be longer than 5 symbols" },
                // "passwordConfirmation": {
                //     validate: val => val === this.state.registrationData.password,
                //     msg: "The password does not match"
                // }
            })

        this.state = {
            registrationData: {
                fullName: "",
                password: "",
                // passwordConfirmation: "",
                email: "",
                termsAccepted: true,
                pendingEamilConfirmation: false
            },
            termsNotAccepted: false,
            loading: false,
            propsValidation: this.filedsValidator.getValidErrorProps(),
        }
    }

    onPropChange(newVal, prop) {
        const registrationDataCopy = Object.assign({}, this.state.registrationData)
        registrationDataCopy[prop] = newVal
        this.setState({ registrationData: registrationDataCopy })
        this.setState({ propsValidation: this.filedsValidator.dicardErrorIfExists(prop) })
    }

    getField(forProp, label, type = "text") {
        return <Form.Field>
            <Form.Input
                className="sp-form-input required"
                id={forProp}
                name={forProp}
                type={type}
                label={label}
                placeholder={label}
                onChange={v => this.onPropChange(v.target.value, forProp)}
                value={this.state.registrationData[forProp]}
                error={this.state.propsValidation[this.filedsValidator.getErrorPropName(forProp)]} />
        </Form.Field>
    }

    register = (e) => {
        e.preventDefault();
        const registrationData = this.state.registrationData
        this.setState({ termsNotAccepted: !registrationData.termsAccepted })
        if (this.validate() && registrationData.termsAccepted) {
            this.setState({ loading: true })
            AuthService.register(registrationData, res => {
                if (res.status === "SUCCESS") {
                    this.setState({ loading: false, pendingEamilConfirmation: true })
                } else {
                    this.setState({ loading: false })
                    Alert.error(res.msg)
                }
            }

            )
        }
    }

    validate() {
        const validationRes = this.filedsValidator.validate(this.state.registrationData)
        this.setState({ propsValidation: validationRes.newErrorProps })
        return validationRes.valid
    }

    regsrationForm() {
        return (
            <div className="sp-form-container">
                <Form onSubmit={this.register}>
                    <div className="registration__form-header">
                        <h1 className="registration__form-heading">Create Account</h1>
                        <div className="sp-divider"></div>
                    </div>
                    {this.getField('fullName', 'Full Name')}
                    {this.getField('email', 'Email')}
                    {this.getField('password', 'Password', 'password')}
                    <p className='info-message'>
                        By registering, you agree to our{' '}
                        <Link className="sp-link" to="/info/termsAndConditions">
                            Terms of Service</Link>{' '}and{' '}
                        <Link className="sp-link" to="/info/privacyPolicy">
                            Privacy Policy
                        </Link>.
                    </p>
                    <div className="sp-form-actions">
                        <button
                            type="submit"
                            className="sp-btn sp-btn--primary sp-btn--lg"
                        >
                            Register
                        </button>
                    </div>
                    <p className='info-text'>
                        Already have an account?{' '}
                        <Link className="sp-link" to="/user/login">
                            Log in
                        </Link>
                    </p>
                </Form>
            </div>
        );
    }

    render() {
        const state = this.state;

        return (
            <div id="app">
                <Header />
                <main id="login-form" className="registration__section">
                    <div className="sp-container-2xs">
                        {state.pendingEamilConfirmation ? (
                            <>
                                <Heading as="h3" textAlign="center">
                                    Your registration was successful.
                                </Heading>
                                
                                <p className='textCenter'>
                                    We have sent an email with a confirmation link to {state.registrationData.email}. Please
                                    allow 5-10 minutes for this message to arrive.
                                </p>
                            </>
                        ) : (
                            <>{state.loading ? <Loader msg="Registration in progress." /> : this.regsrationForm()}</>
                        )}
                    </div>
                </main>
                <Footer />
            </div>
        );
    }
}

export default RegistrationForm


